import { AnimatePresence, motion } from "framer-motion";
import React, { FunctionComponent, useState } from "react";
import { useIntl } from "react-intl";
import HeaderSubCategory from "@Components/atoms/header/HeaderSubCategory";
import { ReactComponent as ChevronBottom } from "@Icons/chevron-bottom.svg";
import { Category, ProductHighlight, SubCategory } from "@Types/header";
import "./style.scss";

interface Props {
  category: Category;
}

const HeaderMobileCategoryItem: FunctionComponent<Props> = ({ category }) => {
  const [displaySubCategories, setDisplaySubCategories] = useState<boolean>(false);

  const intl = useIntl();
  const localeSlug = intl.locale;

  const hasSubCategories =
    (category.subCategories && category.subCategories.length > 0) ||
    (category.productHighlights && category.productHighlights.length > 0);

  const sortedSubCategories = category.subCategories.sort((a, b) => a.priority - b.priority);

  return (
    <div className="HeaderMobileCategoryItem">
      {hasSubCategories ? (
        <>
          <div
            className="HeaderMobileCategoryItem-label"
            onClick={() => setDisplaySubCategories(!displaySubCategories)}
            style={{ color: category.color }}
          >
            {category.title}
          </div>
          <ChevronBottom style={{ transform: `rotate(${displaySubCategories ? 180 : 0}deg)` }} />
          <AnimatePresence initial={false}>
            {displaySubCategories && (
              <motion.div
                animate="open"
                exit="collapsed"
                initial="collapsed"
                transition={{ duration: 0.3 }}
                variants={{
                  open: { height: "auto", opacity: 1 },
                  collapsed: { height: 0, opacity: 0 },
                }}
              >
                <div>
                  {sortedSubCategories.map((subCategory: SubCategory, index: number) => (
                    <HeaderSubCategory key={index} subCategory={subCategory} />
                  ))}
                  {category.productHighlights && (
                    <div className="HeaderSubCategory">
                      {category.productHighlights.map(
                        (productHighlight: ProductHighlight, index: number) => (
                          <a
                            className="HeaderSubCategory-product"
                            key={`${productHighlight.title}-${index}`}
                            href={`/${localeSlug}${productHighlight.url}`}
                          >
                            <div className="HeaderSubCategory-product-title">
                              {productHighlight.title}
                            </div>
                          </a>
                        )
                      )}
                    </div>
                  )}
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </>
      ) : (
        <a
          className="HeaderMobileCategoryItem-label"
          href={`/${localeSlug}${category.url}`}
          style={{ color: category.color }}
        >
          {category.title}
        </a>
      )}
    </div>
  );
};

export default HeaderMobileCategoryItem;
